import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly apiUrl = environment.apiurl;

  constructor(private readonly http: HttpClient) {}
  
  private setHeaders(accept: string = 'application/json'): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: accept,
    });
  }

  private formatErrors(error: unknown): Observable<never> {
    return throwError(() => error);
  }

  private url(path: string): string {
    return `${this.apiUrl}${path}`;
  }
  
  get<T>( path: string, params: HttpParams = new HttpParams(), options?: { responseType?: 'json' | 'blob'; }): Observable<T> {
    if (options?.responseType === 'blob') {
      return this.http.get(this.url(path),
        {
          headers: this.setHeaders('*/*'),
          params,
          responseType: 'blob'
        }
      )
      .pipe(
        catchError(this.formatErrors)
      ) as Observable<T>;
  }
  return this.http.get<T>( this.url(path),{
      headers: this.setHeaders(),
      params
    }
    )
    .pipe(
      catchError(this.formatErrors)
    );
  }

  post<T>(path: string, body: object = {}): Observable<T> {
    const isFormData = body instanceof FormData;
    return this.http
      .post<T>(this.url(path), body, { headers: isFormData ? undefined : this.setHeaders() })
      .pipe(catchError(this.formatErrors));
  }

  put<T>(path: string, body: object = {}): Observable<T> {
    const isFormData = body instanceof FormData;
    return this.http
      .put<T>(this.url(path), body, { headers: isFormData ? undefined : this.setHeaders() })
      .pipe(catchError(this.formatErrors));
  }

  patch<T>(path: string, body: object = {}): Observable<T> {
    return this.http
      .patch<T>(this.url(path), body, { headers: this.setHeaders() })
      .pipe(catchError(this.formatErrors));
  }

  delete<T>(path: string, params: HttpParams = new HttpParams()): Observable<T> {
    return this.http
      .delete<T>(this.url(path), { headers: this.setHeaders(), params })
      .pipe(catchError(this.formatErrors));
  }
}
